import type {
  QueryRankingElementRankingDTO,
  QueryRankingHiddenElementDTO,
  QueryRankingPinnedElementDTO,
} from '@empathyco/playboard-core-domain'
import type { EpbButtonColor } from '../components/shared/epb-button/epb-button.types'
import type { ToolsMessages } from '../models'
import { getCurrentInstance } from 'vue'
import { queryRankingActionConfigs } from '../components/search-query-ranking/config'

export interface QueryRankingElementActionConfig {
  label: string
  labelPast?: string
  color: EpbButtonColor
  action:
    | QueryRankingElementRankingDTO['action']
    | QueryRankingPinnedElementDTO['action']
    | QueryRankingHiddenElementDTO['action']
  icon: string
}

type ActionLabelsMessages = ToolsMessages['configurations']['actionLabels']
export interface GetActionConfigOptions {
  negativeVariant?: boolean
}

interface QueryRankingElementActionsConfigComposable {
  getActionConfig: (
    action: QueryRankingElementActionConfig['action'],
    options?: GetActionConfigOptions,
  ) => QueryRankingElementActionConfig
}

export function useQueryRankingElementActionsConfig(): QueryRankingElementActionsConfigComposable {
  const ctx = getCurrentInstance()
  if (!ctx) {
    throw new Error("'ctx' is not defined")
  }
  const {
    proxy: { $epb },
  } = ctx

  const messages: ActionLabelsMessages = ($epb.messages.tools as ToolsMessages).configurations
    .actionLabels

  return {
    getActionConfig: (
      action: QueryRankingElementActionConfig['action'],
      options?: GetActionConfigOptions,
    ) => getActionConfig(action, messages, options),
  }
}

function getActionConfig(
  action: QueryRankingElementActionConfig['action'],
  messages: ActionLabelsMessages,
  options?: GetActionConfigOptions,
): QueryRankingElementActionConfig {
  const config = queryRankingActionConfigs[action]
  if (!config) {
    throw new Error(`Config not found for action '${action}'`)
  }

  return {
    ...config,
    label: options?.negativeVariant ? messages[action].negative : messages[action].positive,
    labelPast: options?.negativeVariant ? undefined : messages[action].positivePast,
    action,
  }
}
